export default "__VITE_ASSET__eeb75e50__"